export enum GuidelineType {
    Cold = "cold",
    Skin = "skin",
    Moving = "moving",
    Diabetes = "diabetes",
    Vaccinate = "vaccinate",
    Cancer = "cancer",
    Pregnancy = "pregnancy",
}
